export const FEATURE_NAME = {
  // App Info
  DASHBOARD: "DASHBOARD",
  LANDING_PAGE: "LANDING_PAGE",
  LOGOUT: "LOGOUT",

  // Payroll Advance
  PAYROLL_ADVANCE_MANAGEMENT: "PAYROLL_ADVANCE_MANAGEMENT",
  PAYROLL_ADVANCE_LIST: "PAYROLL_ADVANCE_LIST",

  // Company Management
  COMPANY_MANAGEMENT: "COMPANY_MANAGEMENT",
  COMPANY_LIST: "COMPANY_LIST",

  // User
  USER_MANAGEMENT: "USER_MANAGEMENT",
  EMPLOYEE: "EMPLOYEE",
  EMPLOYER: "EMPLOYER",
  BULK_CREATE_EMPLOYEE: "BULK_CREATE_EMPLOYEE",

  // Billing
  BILLING_MANAGEMENT: "BILLING_MANAGEMENT",
  BILLING_LIST: "BILLING_LIST",

  // Profile
  PROFILE: "PROFILE",
};

export const FEATURE_TYPE = {
  ROUTE: "ROUTE",
  LOGOUT: "LOGOUT",
};